import { constants } from '../../config/constants';
import { appendBeforeBodyEnd, createScriptTag } from '../../utils/DOMUtil';

export const loadSurveyScript = () => {
  const dynamicScript = createScriptTag({
    src: constants.MEDALLIA,
    async: true,
  });
  appendBeforeBodyEnd(dynamicScript);
};
